import { useState } from "react";
import Profile from "../../assets/images/Mohanraj.png";
import "../../assets/css/nav.css";
import {
  CCollapse,
  CContainer,
  CNavbar,
  CNavbarBrand,
  CNavbarNav,
  CNavbarToggler,
  CNavItem,
  CNavLink,
} from "@coreui/react";
import { Avatar, Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import GitHubIcon from "@material-ui/icons/GitHub";
import LeetCode from "../../assets/images/LeetCode.png";
import LinkedIn from "../../assets/images/linkedin.png";
import ReactGA from "react-ga4";

export default function Navbars() {
  const [visible, setVisible] = useState(false);
  const [connectDropdownOpen, setConnectDropdownOpen] = useState(false);
  const [testimonialsDropdownOpen, setTestimonialsDropdownOpen] =
    useState(false);

  const handleClose = (x, y) => {
    if (x !== "") {
      ReactGA.event({
        category: "Connect",
        action: "test action",
        label: "test label",
        value: y,
      });
      window.open(x);
    }
  };

  const navigate = useNavigate();

  const resume = () => {
    navigate("/resume");
  };
  const project = () => {
    navigate("/project");
  };
  const skills = () => {
    navigate("/skills");
  };
  const main = () => {
    navigate("/");
    setVisible(false);
  };

  const toggleConnectDropdown = () => {
    setConnectDropdownOpen(!connectDropdownOpen);
  };

  const closeConnectDropdown = () => {
    setConnectDropdownOpen(false);
  };

  const toggleTestimonialsDropdown = () => {
    setTestimonialsDropdownOpen(!testimonialsDropdownOpen);
  };

  const closeTestimonialsDropdown = () => {
    setTestimonialsDropdownOpen(false);
  };

  const handleBrandClick = (event) => {
    event.preventDefault();
    navigate(`/`);
  };

  const handleTestimonial = (x) => {
    navigate(x);
    ReactGA.event({
      category: "Testimonial",
      action: "test action",
      label: "test label",
      value: `${x}`,
    });
  };

  return (
    <div className="navbars" style={{ top: "-1px" }}>
      <CNavbar expand="lg" colorScheme="light">
        <CContainer fluid>
          <CNavbarBrand
            href="/"
            className="d-flex align-items-center"
            onClick={handleBrandClick}
          >
            <Avatar alt="Remy Sharp" src={Profile} />{" "}
            <span className="ms-2 brand">Mohanraj Murugesan</span>
          </CNavbarBrand>
          <CNavbarToggler
            aria-label="Toggle navigation"
            aria-expanded={visible}
            onClick={() => setVisible(!visible)}
            className="toggleBars"
          >
            {visible ? (
              <div className="close"></div>
            ) : (
              <div className="horizontal"></div>
            )}
          </CNavbarToggler>
          <CCollapse className="navbar-collapse" visible={visible}>
            <CNavbarNav className="me-auto mb-2 mb-lg-0 right">
              <CNavItem>
                <CNavLink className="fonts">
                  <Link to="about" spy={true} smooth={true} onClick={main}>
                    {/* <InfoIcon />  */}
                    About
                  </Link>
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className="fonts" onClick={skills}>
                  <span style={{ cursor: "pointer" }}>
                    {/* <AppsIcon />  */}
                    Skills
                  </span>
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className="fonts" onClick={project}>
                  <span style={{ cursor: "pointer" }}>
                    {/* <AppsIcon />  */}
                    Projects
                  </span>
                </CNavLink>
              </CNavItem>
              {/* Assistant removed from navbar to reduce clutter */}

              <CNavItem className="pe-3">
                <CNavLink className="fonts">
                  <div className="dropdown">
                    <div
                      className="dropdown-toggle"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded={testimonialsDropdownOpen}
                      onClick={toggleTestimonialsDropdown}
                    >
                      Testimonials
                    </div>
                    <div
                      className={`dropdown-menu ${
                        testimonialsDropdownOpen ? "show" : ""
                      }`}
                      onClick={closeTestimonialsDropdown}
                    >
                      <div
                        className="dropdown-item"
                        onClick={() => handleTestimonial("/awards")}
                      >
                        Awards
                      </div>
                      <div
                        className="dropdown-item"
                        onClick={() => handleTestimonial("/certifications")}
                      >
                        Certifications
                      </div>
                      <div
                        className="dropdown-item"
                        onClick={() => handleTestimonial("/recommendations")}
                      >
                        Recommendations
                      </div>
                    </div>
                  </div>
                </CNavLink>
              </CNavItem>

              <CNavItem className="pe-3">
                <CNavLink className="fonts">
                  <div className="dropdown">
                    <div
                      className="dropdown-toggle"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded={connectDropdownOpen}
                      onClick={toggleConnectDropdown}
                    >
                      Connect
                    </div>
                    <div
                      className={`dropdown-menu ${
                        connectDropdownOpen ? "show" : ""
                      }`}
                      onClick={closeConnectDropdown}
                    >
                      <div
                        className="dropdown-item"
                        onClick={() =>
                          handleClose(
                            "https://github.com/murugesanmohanraj",
                            "GitHub",
                          )
                        }
                      >
                        <GitHubIcon className="me-2" /> GitHub
                      </div>
                      <div
                        className="dropdown-item"
                        onClick={() =>
                          handleClose(
                            "https://www.linkedin.com/in/murugesanmohanraj",
                            "LinkedIn",
                          )
                        }
                      >
                        <img
                          src={LinkedIn}
                          alt="LinkedIn"
                          className="me-2"
                          style={{ width: 18, height: 18 }}
                        />{" "}
                        LinkedIn
                      </div>
                      <div
                        className="dropdown-item"
                        onClick={() =>
                          handleClose(
                            "https://leetcode.com/u/Mohanraj_Murugesan",
                            "LeetCode",
                          )
                        }
                      >
                        <img
                          src={LeetCode}
                          alt="LeetCode"
                          className="me-2"
                          style={{ width: 18, height: 18 }}
                        />{" "}
                        LeetCode
                      </div>
                    </div>
                  </div>
                </CNavLink>
              </CNavItem>

              <CNavItem>
                <CNavLink className="fonts" href="/">
                  <Link to="contact" spy={true} smooth={true} onClick={main}>
                    {/* <CallIcon />  */}
                    Contact
                  </Link>
                </CNavLink>
              </CNavItem>

              <CNavItem className="resume">
                <Button onClick={resume}>
                  {/* <PortraitIcon />  */}
                  Resume
                </Button>
              </CNavItem>
            </CNavbarNav>
          </CCollapse>
        </CContainer>
      </CNavbar>
    </div>
  );
}
